import React from 'react'

import { CAvatar, CDropdownItem, CSidebarBrand } from '@coreui/react'

import brandFull from 'src/assets/brand/brand-full.svg'
import brandNarrow from 'src/assets/brand/brand-narrow.svg'

import 'simplebar/dist/simplebar.min.css'
import { Sidebar, Menu, MenuItem, SubMenu, menuClasses } from 'react-pro-sidebar'

// sidebar nav config
import navigation from '../_nav'
import {
  selectSidebarUnfoldable,
  setValue as updateSidebarUnfoldable,
} from '../redux/features/sidebarUnfoldable/sidebarUnfoldableSlice'
import { useAppDispatch, useAppSelector } from '../redux/hooks'
import { selectActiveBusinessEntity } from '../redux/features/activeBusinessEntity/activeBusinessEntitySlice'
import { _print_model_data } from '../utils/general'
import { selectCurrentUser } from '../redux/features/currentUser/currentUserSlice'
import { _dictionary } from '../utils/translate'
import { Link } from 'react-router-dom'

const AppSidebarModern = ({ rtl = false, menuDarkMode = false, showLogo = true }) => {
  const dispatch = useAppDispatch()
  const unfoldable = useAppSelector(selectSidebarUnfoldable)
  const activeBusinessEntity = useAppSelector(selectActiveBusinessEntity)

  const currentUser = useAppSelector(selectCurrentUser)
  const translate = _dictionary(currentUser?.active_language || null)

  const theme = menuDarkMode ? 'dark' : 'light'
  const themes = {
    light: {
      sidebar: {
        backgroundColor: '#ffffff',
        color: '#000000',
      },
      menu: {
        menuContent: '#ffffff',
        icon: '#ffffff',
        hover: {
          backgroundColor: '#ffffff',
          color: '#000000',
        },
        disabled: {
          color: '#ffffff',
        },
      },
    },
    dark: {
      sidebar: {
        backgroundColor: '#222222',
        color: '#888888',
      },
      menu: {
        menuContent: '#888888',
        icon: '#666666',
        hover: {
          backgroundColor: '#555555',
          color: '#bbbbbb',
        },
        disabled: {
          color: '#444444',
        },
      },
    },
  }

  const hexToRgba = (hex, alpha) => {
    const r = parseInt(hex.slice(1, 3), 16)
    const g = parseInt(hex.slice(3, 5), 16)
    const b = parseInt(hex.slice(5, 7), 16)

    return `rgba(${r}, ${g}, ${b}, ${alpha})`
  }

  const renderModernMenuItems = (navigation) => {
    return navigation.map((item, i) =>
      item.items ? (
        <SubMenu key={i} label={translate(item.name)}>
          {renderModernMenuItems(item.items)}
        </SubMenu>
      ) : (
        <MenuItem key={i} component={<Link to={item.to} />}>
          {translate(item.name)}
        </MenuItem>
      ),
    )
  }

  return (
    <Sidebar
      collapsed={unfoldable}
      rtl={rtl}
      backgroundColor={hexToRgba(themes[theme].sidebar.backgroundColor, 1)}
      rootStyles={{
        color: themes[theme].sidebar.color,
      }}
    >
      {/*showLogo && (
        <CSidebarBrand className="d-none d-md-flex" to="/">
          <img className="sidebar-brand-full" src={brandFull} alt={'ERP Solution'} />
          <img
            className="sidebar-brand-narrow"
            src={brandNarrow}
            style={{ width: '2rem' }}
            alt={'ERP Solution'}
          />
        </CSidebarBrand>
      )*/}
      <Menu>{renderModernMenuItems(navigation)}</Menu>
      {activeBusinessEntity ? (
        <div className="sidebar-active-be">
          <CDropdownItem>
            {activeBusinessEntity.logo ? (
              <span className="pe-2">
                <CAvatar src={_print_model_data(activeBusinessEntity.logo.url)} size="md" />
              </span>
            ) : null}
            {activeBusinessEntity.title}
          </CDropdownItem>
        </div>
      ) : null}
      {rtl ? (
        <button
          className={`sidebar-fold-toggler ${unfoldable ? 'unfold' : 'fold'}`}
          onClick={() => dispatch(updateSidebarUnfoldable(!unfoldable))}
        />
      ) : (
        <button
          className={`sidebar-fold-toggler ${unfoldable ? 'fold' : 'unfold'}`}
          onClick={() => dispatch(updateSidebarUnfoldable(!unfoldable))}
        />
      )}
    </Sidebar>
  )
}

export default React.memo(AppSidebarModern)
